import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../filters';
import collectCharges from '../employee/applications/appDetails/collectCharges/collectCharges';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";
import { isNullOrEmptyString } from '@devexpress/analytics-core/analytics-internal';

export default {
  name: 'editableTable',
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: {
    refName: {
      type: String,
      required: true
    },
    dataSource: {
      type: Array,
      required: true
    },
    cols: {
      type: Array,
      required: true
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    allowEdit: {
      type: Boolean,
      default: false
    },
    parentButtonFunc: {
      type: Function
    },
    parentEditFunc: {
      type: Function
    },
    allowDelete: {
      type: Boolean,
      default: false
    },
    parentDeleteFunc: {
      type: Function
    },
    allowAddRow: {
      type: Boolean,
      default: false
    },
    parentAddRowFunc: {
      type: Function
    },
    prepareNewItem: {
      type: Function
    },
    allowDissableButton: {
      type: Boolean,
      default: false
      //to allow to dissable button you need this var true
      //and disableButtonFunc function to determin the state
    },
    disableButtonFunc: {
      type: Function
    }
  },
  data: function () {
    return {
      paginatedDataSource: [],
      editRowIndex: -1,
      editColIndex: -1,
      deleteRowIndex: -1,
      showDeleteConfirmation: false,
      newRowAdded: false
    }
  },
  created() {
//    console.log(this.dataSource);
  //  console.log(this.cols);
  },
  watch: {
    
  },
  computed: {
    incompletedFieldMsg() {
      //error msg for incomplete form
      let msg = '';
      this.cols.forEach(element => element.required ? msg = msg + element.label + ', ' : '');
      return "Please complete all required fields: " + msg.slice(0, -2);
    },
  },
  methods: {
    editRow(item, index) {
      this.editRowIndex = index;
      this.editColIndex = -1;
    },
    validateRow(item) {
      //loop throu data to check if all fields marked as required are completed 
      for (let i = 0; i < this.cols.length; i++) {
        //boolean can not be empty
        if (item[this.cols[i].dataType] == 'boolean' && (item[this.cols[i].property] == null  || item[this.cols[i].property] == ''))
          item[this.cols[i].property] = false

        if (this.cols[i].required) {
          if (item[this.cols[i].dataType] != 'boolean' && (item[this.cols[i].property] == null || item[this.cols[i].property] == '')) {
            return false;
          }
        }
      }
      return true;
    },
    saveRow(item, index) {
      //validate data - error trap
      if (!this.validateRow(item)) {
        this.$alertMsg(this.incompletedFieldMsg, 3);
        return;
      }

      //this.editRowIndex = -1;
      //this.editColIndex = -1;

      if (index == 0 && this.newRowAdded) {
        if (this.parentAddRowFunc)
          this.parentAddRowFunc(item, index);

        this.editRowIndex = -1;
        this.editColIndex = -1;
        this.newRowAdded = false;

      } else {
        if (this.parentEditFunc)
          if (!this.parentEditFunc(item, index)) {
            this.editRowIndex = -1;
            this.editColIndex = -1;
          }
      }
    }, 
    deleteRow(item, index) {
      this.deleteRowIndex = index;
      this.showDeleteConfirmation = true;
    },
    ConfirmDelete() {

      if (this.deleteRowIndex == 0 && this.newRowAdded) {
        this.dataSource.splice(this.deleteRowIndex, 1);
        this.deleteRowIndex = -1;
        this.showDeleteConfirmation = false;
        this.editRowIndex = -1;
        this.newRowAdded = false;
        return;
      }

      this.showDeleteConfirmation = false;

      if (this.parentDeleteFunc)
        this.parentDeleteFunc(this.deleteRowIndex);

      this.deleteRowIndex = -1;
    },
    cancelDelete() {
      this.deleteRowIndex = -1;
      this.showDeleteConfirmation = false;
    },
    editCell(rowIdx, colIdx) {
      if (!this.cols[colIdx].allowEdit && (!this.cols.rowValidation && !this.dataSource[rowIdx]['allowEdit' + this.cols[colIdx].property])) {
        this.editColIndex = -1;
        this.editRowIndex = -1;
        return;
      }

      this.editRowIndex = rowIdx;
      this.editColIndex = colIdx;
    },
    addRow() {
      if (this.newRowAdded)
        return;

      if (this.prepareNewItem) {
        const newRow = this.prepareNewItem();
        this.dataSource.unshift(newRow);

        this.editRowIndex = 0;
        this.newRowAdded = true;
        return;
      }

      let emptyRow = {};

      for (var i = 0; i < this.cols.length; i++) {
        emptyRow[this.cols[i].property] = null;

        if (this.cols[i].rowDataSource)
          emptyRow['listSource' + this.cols[i].property] = [];

        if (this.cols[i].rowValidation)
          emptyRow['allowEdit' + this.cols[i].property] = true;
      }

      this.dataSource.unshift(emptyRow);
      this.editRowIndex = 0;

      this.newRowAdded = true;
    },
    selectSelectionChanged(rowIdx, colIdx) {
      if (!this.cols[colIdx].changeFunc)
        return;

        const val = this.dataSource[rowIdx][this.cols[colIdx].property];
      this.cols[colIdx].changeFunc(rowIdx, val);
      this.$forceUpdate();
    },
    getDisplayLabel(rowIdx, colIdx) {
      if (this.cols[colIdx].dataType == 'select') {
        
        if (this.cols[colIdx].rowDataSource) {
          if (this.dataSource[rowIdx]['listSource' + this.cols[colIdx].property] != null && this.dataSource[rowIdx]['listSource' + this.cols[colIdx].property].filter(a => a[this.cols[colIdx].valueField] == this.dataSource[rowIdx][this.cols[colIdx].property]).length == 0) {
            return this.dataSource[rowIdx][this.cols[colIdx].displayModel];
          }
          else {
            if (this.dataSource[rowIdx]['listSource' + this.cols[colIdx].property] != null && this.dataSource[rowIdx]['listSource' + this.cols[colIdx].property].filter(a => a[this.cols[colIdx].valueField] == this.dataSource[rowIdx][this.cols[colIdx].property]).length == 0) {
              return this.dataSource[rowIdx][this.cols[colIdx].displayModel];
            }
            else {
              return this.dataSource[rowIdx]['listSource' + this.cols[colIdx].property] != null ? this.dataSource[rowIdx]['listSource' + this.cols[colIdx].property].filter(a => a[this.cols[colIdx].valueField] == this.dataSource[rowIdx][this.cols[colIdx].property])[0][this.cols[colIdx].displayField] : '';
            }
          }
        } else {
          return this.cols[colIdx].dataSource.filter(a => a[this.cols[colIdx].valueField] == this.dataSource[rowIdx][this.cols[colIdx].property]).length == 0 ? 
            this.dataSource[rowIdx][this.cols[colIdx].displayModel] :
          this.cols[colIdx].dataSource.filter(a => a[this.cols[colIdx].valueField] == this.dataSource[rowIdx][this.cols[colIdx].property])[0][this.cols[colIdx].displayField];
        }
      }
      else {
        return this.dataSource[rowIdx][this.cols[colIdx].property];
      }
    },
    formatDate(val) {
      if (isNullOrEmptyString(val))
        return '';

      return moment(val).format('DD/MM/YYYY HH:mm');
    }
  }
}

